import React, {Fragment, useState} from "react";
import CollapsibleTable from "../../tableComponents/CollapsibleTable";
import EAButtonBar from "../../EAButtonBar";
import EAButton from "../../EAButton";
import EACrudDialog from "../../EACrudDialog";
import {
    PARAMETERART_FRACHT,
    PARAMETERART_KONZENTRATION,
    PARAMETERART_MENGE,
    parameterartIdToObj,
} from "../../../consts/anforderungParameterart";
import {deleteIndexedValue, storeIndexedValue} from "../../../utils/IndexedArray";
import {useConfirmation} from "../../ConfirmationDialog/ConfirmationDialogProvider";
import {confirmDeleteOption} from "../../ConfirmationDialog/confirmationDialogOptions";

export function AnforderungenTabComponent({
    anforderungen,
    modus,
    setAnforderungen,
    schema,
    anforderungArt,
    initialAnforderung,
    buildDlgContent,
    createColumns,
    loading,
}) {
    const confirm = useConfirmation();
    const [dlgStatus, setDlgStatus] = useState({ open: false });
    const [volatileAnforderung, setVolatileAnforderung] = useState({});

    function handleDlgOpen(anforderung, index, readOnly = false) {
        setVolatileAnforderung({ ...anforderung, index });
        setDlgStatus({ open: true, readOnly: readOnly });
    }

    function handleSaveAnforderung(newAnforderung) {
        const parameterArt = newAnforderung.parameterArt.id;
        const newAnforderungen = [...anforderungen[parameterArt]];
        storeIndexedValue(newAnforderungen, newAnforderung);
        closeDlg();
        setAnforderungen({ ...anforderungen, [parameterArt]: newAnforderungen });
    }

    function handleDeleteAnforderung() {
        confirm(confirmDeleteOption("die Anforderung", () => {
                const parameterArt = volatileAnforderung.parameterArt.id;
                const newAnforderungen = [...anforderungen[parameterArt]];
                deleteIndexedValue(newAnforderungen, volatileAnforderung);
                closeDlg();
                setAnforderungen({...anforderungen, [parameterArt]: newAnforderungen});
            })
        );
    }

    function closeDlg() {
        setDlgStatus({ open: false });
    }

    function buildDlgTitle() {
        if (dlgStatus.readOnly) {
            return anforderungArt + " lesen";
        } else {
            return anforderungArt + (volatileAnforderung.index === -1 ? " hinzufügen" : " bearbeiten");
        }
    }

    function createAnforderungCrudTable(label, parameterArt) {
        return (
            <Fragment>
                <CollapsibleTable
                    id={"anforderungsTbl-" + label}
                    label={label}
                    columns={createColumns(handleDlgOpen)}
                    tablerest={{ className: "noHorizontalPadding" }}
                    data={anforderungen ? anforderungen[parameterArt] : anforderungen}
                    loading={loading}
                />
                <EAButtonBar>
                    {modus === "s" && (
                        <EAButton
                            id={"add" + label}
                            loading={loading}
                            disabled={loading}
                            label="Hinzufügen"
                            onClick={() => handleDlgOpen({ ...initialAnforderung, parameterArt: parameterartIdToObj(parameterArt) }, -1)}
                        />
                    )}
                </EAButtonBar>
            </Fragment>
        );
    }

    return (
        <div className="gridl tabsheet-content-margin">
            <EACrudDialog
                open={dlgStatus.open}
                schema={schema}
                readOnly={dlgStatus.readOnly}
                title={buildDlgTitle()}
                submitTitle="Übernehmen"
                onClose={() => closeDlg()}
                obj={volatileAnforderung}
                onSaveobj={handleSaveAnforderung}
                buildContent={(formFactory) => buildDlgContent(formFactory, volatileAnforderung?.parameterArt?.id)}
                renderAdditionalActions={() =>
                    !dlgStatus.readOnly && volatileAnforderung.index !== -1 ? (
                        <EAButton
                            id="deleteAnforderung"
                            label="Löschen"
                            style={{ marginRight: "auto" }}
                            onClick={handleDeleteAnforderung}
                        />
                    ) : null
                }
            />
            {createAnforderungCrudTable("Konzentration", PARAMETERART_KONZENTRATION)}
            {createAnforderungCrudTable("Menge", PARAMETERART_MENGE)}
            {createAnforderungCrudTable("Fracht", PARAMETERART_FRACHT)}
        </div>
    );
}
